import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import { AppUserService } from '../services/app-user.service';
import { GlobalVariable } from '../config/variable';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  globalVariable = GlobalVariable;
  constructor(private appUserService: AppUserService) {
  }


  // 获取随机数
  getRandom() {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0].toString();
  }

  // SHA256加密
  sha256(message: string) {
    return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
  }

  // base64加密
  base64(message: string) {
    const wordArray = CryptoJS.enc.Utf8.parse(message);
    return CryptoJS.enc.Base64.stringify(wordArray);
  }

  // 获取当前时间戳
  getTimeStamp() {
    return Date.parse(new Date().toString()).toString();
  }

  // 获取时间戳
  getDateStamp() {
    return new Date().getTime();
  }

  // 生GUID
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: any) => {
      // tslint:disable-next-line:no-bitwise
      const r = (Math.random() * 16) | 0;
      // tslint:disable-next-line:no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // 生成头 authorization
  getHeader() {
    let secret = '';
    let appKey = '';
    const random = this.getRandom();
    const timeStamp = this.getTimeStamp();
    const signature = this.sha256(random + timeStamp + secret);
    return this.base64(`${appKey}.${random}.${timeStamp}.${signature}`);
  }

  // AES加密
  aes(message: string) {
    let secret = '';
    return CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(secret), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
  }


  // AES256加密
  aes256(message: string, secret: string, iv: string) {
    var ciphertext = CryptoJS.AES.encrypt(message, CryptoJS.enc.Hex.parse(secret), {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return ciphertext.toString();
  }

  // rsa加密
  rsaEncrypt = (password: string) => new Promise((reslove:any) => {
    let encryptor = new JSEncrypt();  // 创建加密对象实例
    let rsaPassWord: any = password;  // 对内容进行加密
    //之前生成的公钥，复制的时候要小心不要有空格(此处把密钥省略了，自己写的时候可把自己生成的公钥粘到对应位置)
    // this.appUserService.GetRSAPubKey().subscribe((r: any) => {
    encryptor.setPublicKey(this.globalVariable.rsaPublickKey) //设置公钥
    if (this.globalVariable.rsaPublickKey) rsaPassWord = encryptor.encrypt(password);
    reslove(rsaPassWord)
    // })
  })

  // 使用rsa公钥加密
  rsaPublicEncrypt(message: string) {
    let encryptor = new JSEncrypt()  // 创建加密对象实例
    encryptor.setPublicKey(this.globalVariable.rsaPublickKey) //设置公钥
    let s: any = encryptor.encrypt(message);
    // console.log('--------encryptor----', s)
    return s;
  }

}
